import { AlertCircle, CheckCircle2, XCircle } from "lucide-react";
import React from "react";

export interface StatusContent {
  icon: React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>;
  iconClass: string;
  title: string;
  description: string;
  footerText: string;
  footerBgClass: string;
  footerTextClass: string;
}

export const STATUS_MAP: Record<string, StatusContent> = {
  success: {
    icon: CheckCircle2,
    iconClass: "fill-[#17922C]",
    title: " Aadhaar Access Successful",
    description: "You have successfully granted access for masked Aadhaar details",
    footerText: "You can close this tab. Our store executive will guide you for further steps",
    footerBgClass: "bg-[#3385FF0F]",
    footerTextClass: "text-[#0052CC]",
  },
  failed: {
    icon: AlertCircle,
    iconClass: "fill-[#E21111]",
    title: "Aadhaar Access Failed",
    description: "Could not proceed with verification as access was denied",
    footerText: "Aadhaar access is needed to complete verification",
    footerBgClass: "bg-[#E24F4F0F]",
    footerTextClass: "text-[#E21111]",
  },
  expired: {
    icon: XCircle,
    iconClass: "fill-[#E21111]",
    title: "Link Expired",
    description: "The link you followed has expired. Please try again.",
    footerText: "",
    footerBgClass: "",
    footerTextClass: "",
  }
};